import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import CloseIcon from '@mui/icons-material/Close';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { isLoggedIn } from '../authProvider/AuthContext';
import { CLEAR_FORM_DATA } from '../../redux-state/types';
import { useDispatch } from 'react-redux';

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const email = localStorage.getItem('email');
  const first_name = localStorage.getItem('first_name');
  const last_name = localStorage.getItem('last_name');

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = async () => {
    localStorage.clear();
    dispatch({
      type: CLEAR_FORM_DATA,
    });
    navigate('/login');
  };

  const redirectToDashboard = () => {
    if (isLoggedIn()) {
      navigate('/dashboard');
    }
  };

  return (
    <header>
      <div className="flex justify-between">
        <div className="flex items-center cursor-pointer pl-6 pt-4" onClick={redirectToDashboard}>
          <div className="h-11 w-11 rounded-full flex items-center justify-center">
           <img className="rounded-full max-w-none" src="/logo.png" alt="Dashboard visual" style={{ width: "60px", height: "60px" }}/>
          </div>
          <p className="text-xl font-bold ml-2">DMV Navigator</p>
        </div>

        <div className="flex flex-row">
          <div className='flex flex-row cursor-pointer' onClick={handleMenuOpen}>
            <div className="flex items-center mt-2 mr-2">
              <AccountCircleIcon  style={{ fontSize: 44 }} />
            </div>
            {first_name && last_name ? (
            <div className="flex flex-col text-sm mr-2 pt-4">
              <div className="font-bold">{first_name} {last_name}</div>
              <div className="text-xs">{email}</div>
            </div>): (<div className="flex flex-col text-sm mr-2 pt-4">
              <div className="font-bold">Username</div>
              <div className="text-xs">{email}</div>
            </div>)}

            <KeyboardArrowDownIcon onClick={handleMenuOpen} className="mt-6" />
          </div>

          <div className="flex items-center mr-4">
            <Menu
              anchorEl={anchorEl}
              open={open}
              className="relative"
              onClose={handleMenuClose}
              PaperProps={{
                sx: {
                  borderRadius: 2,
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                  minWidth: '300px',
                  padding: '10px',
                  backgroundColor: '#fff',
                },
              }}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <div className="flex justify-end items-center mb-2 absolute right-2">
                <CloseIcon onClick={handleMenuClose} className="rounded" style={{ fontSize: 22, backgroundColor: "#F2F4F7" }} />
              </div>

              {first_name && last_name ? (
              <div className="flex flex-col items-center border-b border-gray-200 px-16 pb-4">
                <div className="mb-3">
                  <AccountCircleIcon  style={{ fontSize: 54 }} />
                </div>
                <div className="font-semibold mb-2">{first_name} {last_name}</div>
                <div className="text-sm text-gray-600">{email}</div>
              </div>
              ) : (
                <div className="flex flex-col items-center border-b border-gray-200 px-16 pb-4">
                <div className="mb-3">
                  <AccountCircleIcon  style={{ fontSize: 54 }} />
                </div>
                <div className="font-semibold mb-2">Username</div>
                <div className="text-sm text-gray-600">{email}</div>
              </div>
              )}


              <MenuItem
                onClick={handleLogout}
                sx={{
                  color: 'red',
                  fontWeight: 'bold',
                  marginTop: '10px',
                }}
              >
                <img src="/icons/logout-icon.png" className='mr-2' alt="logout" />
                Logout
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
